/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
// carousel-drag.js
function initCarouselDrag() {
    const carousels = document.querySelectorAll('.wp-block-lahormiga-blocks-home-carousel .track');
    
    carousels.forEach(carousel => {
        if (window.matchMedia('(hover: hover)').matches) {
            carousel.style.cursor = 'grab';
            
            let isDragging = false;
            let startX, scrollLeft;
            let moved = false; 
            
            const mouseMove = (e) => {
                if (!isDragging) return;
                
                const x = e.pageX - carousel.offsetLeft;
                const walk = x - startX;
                
                if (Math.abs(walk) > 5) {
                    moved = true;
                    carousel.scrollLeft = scrollLeft - walk;
                }
            };
            
            const mouseUp = (e) => {
                carousel.style.cursor = 'grab';
                document.removeEventListener('mousemove', mouseMove);
                document.removeEventListener('mouseup', mouseUp);
                
                if (moved) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                
                isDragging = false;
            };
            
            carousel.addEventListener('mousedown', (e) => {
                isDragging = true;
                moved = false; 
                carousel.style.cursor = 'grabbing';
                
                startX = e.pageX - carousel.offsetLeft;
                scrollLeft = carousel.scrollLeft;
                
                document.addEventListener('mousemove', mouseMove);
                document.addEventListener('mouseup', mouseUp);
                e.preventDefault();
            });
            
            carousel.addEventListener('click', (e) => {
                if (moved) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }, true);
        }
    });
}

document.addEventListener('DOMContentLoaded', initCarouselDrag);
/* eslint-enable no-console */
